import type { Site } from '~/interfaces/site';
import { findAndInsertProprietaryNode } from '~/utils/findAndInsertProprietaryNode';

import { serializeNode } from './nodes/serializeNode';

interface FooterSerializerProps {
  site: Site;
}

const FooterSerializer = ({ site }: FooterSerializerProps) => {
  const footerData = site.viewable_site_version.footer;
  const webTheme = site.publication.web_theme;

  return serializeNode(findAndInsertProprietaryNode(footerData, webTheme), 'footer');
};

export default FooterSerializer;
